import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12.984",
      cy: "12",
      r: "8",
      fill: "#121212"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M11.072 13.849 9 12.193a.704.704 0 0 0-.841 0c-.233.186-.233.487 0 .673l2.495 1.994a.704.704 0 0 0 .841 0l6.315-5.048c.233-.186.233-.486 0-.672a.704.704 0 0 0-.842 0l-5.896 4.709Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "check_solid"}) } }